import React from 'react';
import ReactDOM,{render} from 'react-dom';
import configureStore from './store';
import { Provider } from 'react-redux';

import FeaturesPage from './containers/Features';
import RouteGuest from './router';
import registerServiceWorker from './registerServiceWorker';
// assets 

import 'babel-polyfill';
import './assets/css/main.scss';
import './assets/js';


const store = configureStore();
ReactDOM.render(
    <Provider store = {store}>
        <RouteGuest />
    </Provider>,document.getElementById('root'));

// registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js